import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import 'rxjs/add/operator/switchMap';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { ContratosService } from "../../../services/contratos.service";

@Component({
  selector: 'formulario-contrato',
  templateUrl: './formulario-contrato.component.html'
})
export class FormularioContratoComponent implements OnInit {

    @Input() public idCreditos: number = null;
    @Input() public isCompleted: boolean = false;
    @Input() public isEditable: boolean = false;
    @Output() public onDataUpdated: EventEmitter<string> = new EventEmitter;
    //UI attributes
    public showContract: boolean = false;
    private isInitialized: boolean = false;
    public isLoadComplete: boolean = false;
    public errors: any = {};
    //File helperes
    public creatingContract: boolean = false;
    public contratoFile: object = null;
    public uploadingContract: boolean = false;
    //Subscriptions
    private changeSubscription: any = null;

    constructor(
      private helperService: HelpersService,
      private creditosService: CreditosService,
      private contratosService: ContratosService
    ){
        this.changeSubscription = this.creditosService.changeCredito.subscribe( () => {
          this.setupComponent();
        });
    }

    ngOnInit() {
        
    }

    ngOnDestroy () {
      //Se necesita hacer el unsubscribe cuando se libera el componente, 
      //ya que de no hacerlo se encolan las subscripciones y la función se puede disparar N veces
      this.changeSubscription.unsubscribe();
    }

    public ngOnChanges(changes: SimpleChanges) {
      if (changes.isCompleted && this.isCompleted) {
        this.showContract = true;
      }
    }

    public loadComponent(){
      //Si alguno de los formularios del crédito se completa, este evento requiere que se vuelva a consultar la información
      //para saber si el crédito ya es valido para crear su contrato
      if(!this.isInitialized){
        this.setupComponent();
        this.isInitialized = true; 
        
      }
    }

    private setupComponent(){
      //Obtener la info del crédito para configurar el componente
      this.getContratoFile(this.idCreditos);
    }

    /**
     * 
     * Obtiene la información del archivo asociado al contrato
     */
    private getContratoFile(idCreditos : number){
      this.contratosService.get(idCreditos).subscribe(
        (response)=>
        {
          let contratoFile = response.json().content;

          if(contratoFile){
            this.contratoFile = contratoFile;
          }
          
          this.isLoadComplete = true;
          //Si la sección de contrato ya esta completa, no necesitamos volver a validar las secciones del crédito.
          //En este punto sabemos que es valido mostrar los detalles del contrato
          if(!this.showContract){
            this.validateStatus(idCreditos);
          }

        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    private validateStatus(idCreditos : number){
      this.creditosService.isValidToCreateContrato(idCreditos).subscribe(
          (response)=>
          {
            const result = response.json().content;
            this.showContract = result.isValid;
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
    
    /**
     * Upload files
     */
    public fileChange(event) {
      //Show spinner
      this.uploadingContract = true;
      let observableResponse = this.contratosService.save(event, this.idCreditos);

      if(!observableResponse){
        //Si al hacer el Upload del archivo se cancela la carga, cae en este escenario 
        this.uploadingContract = false;
        return;
      }

      observableResponse.subscribe(
        (response)=>
        {
          let contratoFile = response.json().content;
          this.contratoFile = contratoFile;
          //Hide spinner
          this.uploadingContract = false;
          //Notify result
          this.helperService.notification('Contrato agregado', 'Se ha agregado exitosamente el archivo', 'success');

          //Informar a los otros componentes que ya se completo la sección de contrato
          this.onDataUpdated.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
      
    }

    public deleteContratoFile(){

      this.contratosService.delete(this.idCreditos).subscribe(
        (response)=>
        {
          //Si el archivo fue eliminado, desasignamos el valor del atributo contratoFile
          this.contratoFile = null;
          this.helperService.notification('Contrato eliminado', 'Se ha eliminado exitosamente el archivo ', 'success');

          //Informar a los otros componentes que esta incompleta la sección de Contrato
          this.onDataUpdated.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public downloadFile() {
      this.contratosService.getImageUrl(this.idCreditos).subscribe(
        (response)=>
        {
          const fileUrl = window.URL.createObjectURL(response.blob());
          //Muestra el archivo en una nueva ventana
          window.open(fileUrl);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public downloadContratoPDF() {
      //Mostrar spinner
      this.creatingContract = true;
      this.contratosService.getContratoPDF(this.idCreditos).subscribe(
        (response)=>
        {
          const fileUrl = window.URL.createObjectURL(response.blob());
          //Muestra el archivo en una nueva ventana
          window.open(fileUrl);
          //Ocultar spinner ya que el archivo termino de crearse
          this.creatingContract = false;
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

}



// WEBPACK FOOTER //
// ./src/app/creditos/components/formulario-contrato/formulario-contrato.component.ts